module.exports = __webpack_public_path__ + "img/nightshroud.46eba2d4.png";